/**
 * Google reCAPTCHA v3 helper for public pages.
 *
 * Loads the script once per site key and returns a token for ``action``.
 */

function loadExternalScript(src, id) {
  return new Promise((resolve, reject) => {
    if (typeof document === 'undefined') {
      resolve();
      return;
    }
    if (document.getElementById(id)) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(script);
  });
}

export async function executeRecaptchaV3(siteKey, action = 'submit') {
  if (!siteKey) return '';
  const src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
  await loadExternalScript(src, 'ty-recaptcha-v3');
  const grecaptcha = window.grecaptcha;
  if (!grecaptcha) {
    throw new Error('reCAPTCHA failed to load. Please refresh and try again.');
  }
  return new Promise((resolve, reject) => {
    grecaptcha.ready(() => {
      grecaptcha.execute(siteKey, { action }).then(resolve).catch(reject);
    });
  });
}
